import React from "react";
import "./ResidentialCheckList.css";


function ResidentialCheckList()
{

    return(

        <div className="mb-3 form-check">
        <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
        <label className="dropdown-label" for="flexCheckDefault">
        Default checkbox</label>
  </div>


    );
}

export default ResidentialCheckList;